<template>
	<div class="page">
		<h2 class="title">活动配置</h2>
		
		<el-form label-position="left" :model="ruleForm" :rules="ruleData" ref="formRef" label-width="100px" class="demo-ruleForm">
			<!-- 时间配置 -->
			<div class="section">
				<h3 class="section-title">时间配置</h3>
				
				<el-form-item label="活动名称" prop="name">
					<el-input v-model="ruleForm.name" class="w500" maxlength="100" placeholder="请输入活动名称"></el-input>
				</el-form-item>
				
				<el-form-item label="上线时间" prop="onlineTime">
					<el-date-picker 
						v-model="ruleForm.onlineTime" 
						type="datetime" 
						class="w500"
						placeholder="选择上线时间"
						value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>
					<span class="tip">活动页面可被访问的时间</span>
				</el-form-item>
				
				<el-form-item label="报名时间" prop="registrationEndTime">
					<el-date-picker 
						v-model="registrationTime" 
						type="datetimerange" 
						class="w500"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>
					<span class="tip">用户可以报名的时间段</span>
				</el-form-item>
				
				<el-form-item label="下线时间" prop="offlineTime">
					<el-date-picker 
						v-model="ruleForm.offlineTime" 
						type="datetime" 
						class="w500"
						placeholder="选择下线时间"
						value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>
					<span class="tip">活动页面下线的时间</span>
				</el-form-item>
				
				<el-form-item label="状态" prop="status">
					<el-radio-group v-model="ruleForm.status">
						<el-radio :label="1">开启</el-radio>
						<el-radio :label="2">关闭</el-radio>
					</el-radio-group>
				</el-form-item>
			</div>
			
			<!-- 页面配置 -->
			<div class="section">
				<h3 class="section-title">页面配置</h3>
				
				<el-table :data="pageConfigs" border class="config-table"> 
					<el-table-column prop="index" label="序号" width="300" align="center"></el-table-column>
					<el-table-column prop="name" label="名称" align="center"></el-table-column>
					<el-table-column prop="action" label="操作" width="200" align="center">
						<template slot-scope="scope">
							<el-button type="text" @click="handleConfig(scope.row)">配置</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			
			<!-- Banner配置弹窗 -->
			<el-dialog title="配置" center  :visible.sync="bannerDialogVisible" width="650px" :close-on-click-modal="false">
				<el-form :model="ruleForm" :rules="ruleData" ref="bannerFormRef" label-width="80px">
          <div class="flex">
            <el-form-item label="PC" prop="pcBannerImage" :error="uploadErrorInfo1">
              <div class="upload-box">
                <wk-upload
                  accept=".png,.PNG,.jpg,.JPG,jpeg,JPEG"
                  @uploadChange="handlePcImgChange"
                  :before-upload-fn="beforeUpload"
                  :imgUrl="ruleForm.pcBannerImage"
                  @uploadError="handleImgError"
                ></wk-upload>
                <span class="upload-tip">
                  请上传PNG/JPG格式
                  <br>大小2MB以内。
                </span>
              </div>
            </el-form-item>

            <el-form-item class="margin-l20" label="H5" prop="h5BannerImage" :error="uploadErrorInfo2">
              <div class="upload-box">
                <wk-upload
                  accept=".png,.PNG,.jpg,.JPG,jpeg,JPEG"
                  @uploadChange="handleH5ImgChange"
                  :before-upload-fn="beforeUpload"
                  :imgUrl="ruleForm.h5BannerImage"
                  @uploadError="handleImgError"
                ></wk-upload>
                <span class="upload-tip">
                  请上传PNG/JPG格式
                  <br>大小2MB以内。
                </span>
              </div>
            </el-form-item>

          </div>

					<el-form-item label="底色" prop="backgroundColor">
						<el-input v-model="ruleForm.backgroundColor" placeholder="#fff" class="backgroundColor-btn"></el-input>
						<span class="upload-tip">请输入16进制的hex色值</span>
					</el-form-item>

          <div class="text-center">
            <el-button @click="bannerDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitBanner">提交</el-button>
          </div>
				</el-form>
			</el-dialog>
			
			<!-- 报名规则配置弹窗 -->
			<el-dialog title="配置" center :visible.sync="ruleDialogVisible" width="650px" :close-on-click-modal="false">
				<el-form :model="ruleForm" :rules="ruleData" ref="ruleFormRef" >
					<el-form-item label="报名规则" prop="rules">
						<el-input type="textarea" v-model="ruleForm.rules" :rows="8" placeholder="请输入报名规则" maxlength="1000" show-word-limit></el-input>
					</el-form-item>
          <el-form-item class=" text-center">
            <el-button @click="ruleDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitRule">提交</el-button>
          </el-form-item>
				</el-form>
			</el-dialog>
			
			<div class="foot">
				<el-button class="w100" @click="cancel()">取消</el-button>
				<el-button class="w100" type="primary" @click="onSubmit()">保存</el-button>
				<el-button class="w100" type="primary" @click="onPreview()">预览</el-button>
			</div>
		</el-form>
	</div>
</template>
<script>
import store from '@/store/index.js';
export default {
    beforeRouteEnter: (to,from,next) => {
        store.commit("breadcrumbStore/setMenuBreadcrumb", {'menu': to.meta.menuBreadcrumb, name:to.query.id? "编辑活动":'添加活动', path: to.fullPath} );
        next()
    },
    data() {
        const validateOnlineTime = (rules, value, callback) => {
            if (value && this.ruleForm.offlineTime) {
                const online = new Date(value).getTime();
                const offline = new Date(this.ruleForm.offlineTime).getTime();
                if (online > offline) {
                    callback(new Error('上线时间不能大于下线时间'));
                    return;
                }
            }
            callback();
        };
        
        const validateOfflineTime = (rules, value, callback) => {
            if (value && this.ruleForm.onlineTime) {
                const online = new Date(this.ruleForm.onlineTime).getTime();
                const offline = new Date(value).getTime();
                if (offline < online) {
                    callback(new Error('下线时间不能小于上线时间'));
                    return;
                }
            }
            callback();
        };
        
        const validateRegistrationStartTime = (rules, value, callback) => {
            // 报名开始时间必须 >= 上线时间
            if (value && this.ruleForm.onlineTime) {
                const registrationStart = new Date(value).getTime();
                const online = new Date(this.ruleForm.onlineTime).getTime();
                if (registrationStart < online) {
                    callback(new Error('报名开始时间不能早于上线时间'));
                    return;
                }
            }
            // 报名开始时间必须 <= 报名结束时间
            if (value && this.ruleForm.registrationEndTime) {
                const registrationStart = new Date(value).getTime();
                const registrationEnd = new Date(this.ruleForm.registrationEndTime).getTime();
                if (registrationStart > registrationEnd) {
                    callback(new Error('报名开始时间不能大于报名结束时间'));
                    return;
                }
            }
            callback();
        };
        
        const validateRegistrationEndTime = (rules, value, callback) => {
            // 报名结束时间必须 <= 下线时间
            if (value && this.ruleForm.offlineTime) {
                const registrationEnd = new Date(value).getTime();
                const offline = new Date(this.ruleForm.offlineTime).getTime();
                if (registrationEnd > offline) {
                    callback(new Error('报名结束时间不能晚于下线时间'));
                    return;
                }
            }
            // 报名结束时间必须 >= 报名开始时间
            if (value && this.ruleForm.registrationStartTime) {
                const registrationStart = new Date(this.ruleForm.registrationStartTime).getTime();
                const registrationEnd = new Date(value).getTime();
                if (registrationEnd < registrationStart) {
                    callback(new Error('报名结束时间不能小于报名开始时间'));
                    return;
                }
            }
            callback();
        };
        
        return {
            uploadErrorInfo: '', // 上传的错误
            registrationTime: [], 
            ruleForm: {
                id: '',
                name: '',
                onlineTime: null,
                registrationStartTime: null,
                registrationEndTime: null,
                offlineTime: null,
                status: 1,
                pcBannerImage: '',
                h5BannerImage: '',
                backgroundColor: '#000000',
                rules: '',
            },
            ruleData: {
                name: [
                    {required: true, message: '请输入活动名称', trigger: ['change', 'blur']},
                ],
                onlineTime: [
                    {required: true, message: '请选择上线时间', trigger: ['change', 'blur']},
                    {validator: validateOnlineTime, message: '上线时间不能大于下线时间', trigger: ['change', 'blur']}
                ],
                registrationStartTime: [
                    {required: true, message: '请选择报名时间', trigger: ['change', 'blur']},
                    {validator: validateRegistrationStartTime, message: '报名时间必须在活动上线和下线时间之间', trigger: ['change', 'blur']}
                ],
                registrationEndTime: [
                    {required: true, message: '请选择报名时间', trigger: ['change', 'blur']},
                    {validator: validateRegistrationEndTime, message: '报名时间必须在活动上线和下线时间之间', trigger: ['change', 'blur']}
                ],
                offlineTime: [
                    {required: true, message: '请选择下线时间', trigger: ['change', 'blur']},
                    {validator: validateOfflineTime, message: '下线时间不能小于上线时间', trigger: ['change', 'blur']}
                ],
                status: [
                    {required: true, message: '请选择状态', trigger: 'change'}
                ],
                pcBannerImage: [
                    { required: true, message: '请上传PC图片', trigger: 'change' },
                ],
                h5BannerImage: [
                    { required: true, message: '请上传H5图片', trigger: 'change' },
                ],
                backgroundColor: [
                    { required: true, message: '请输入底色', trigger: 'blur' },
                ],
                rules: [
                    { required: true, message: '请输入报名规则', trigger: 'blur' },
                    { maxLength: 1000, message: '报名规则不能超过1000个字符', trigger: 'blur' },
                ],
            },
            pageConfigs: [
                { index: 1, name: 'banner及底色', key: 'banner' },
                { index: 2, name: '报名规则', key: 'rules' },
            ],
            // Banner弹窗
            bannerDialogVisible: false,
            uploadErrorInfo1: '', // PC图片上传错误
            uploadErrorInfo2: '', // H5图片上传错误
            // 报名规则弹窗
            ruleDialogVisible: false,
        }
    },
    watch: {
        'registrationTime'(val) {
            console.log(val)
            if (val && val.length === 2) {
                this.ruleForm.registrationStartTime = val[0];
                this.ruleForm.registrationEndTime = val[1];
            }
        }
    },
    created() {
        if (this.$route.query.id){
            this.loadData(this.$route.query.id)
        }
    },
    methods: {
        loadData(id) {
            this.$apis.activityEnrollServer.queryDetail({
                id: id
            }).then(res => {
                if (res['code'] == 0) {
                    const data = res.data
                    // 将时间戳转换为日期字符串
                    if (data.onlineTime) {
                        data.onlineTime = this.formatTimestamp(data.onlineTime)
                    }
                    if (data.registrationStartTime) {
                        data.registrationStartTime = this.formatTimestamp(data.registrationStartTime)
                    }
                    if (data.registrationEndTime) {
                        data.registrationEndTime = this.formatTimestamp(data.registrationEndTime)
                    }
                    if (data.offlineTime) {
                        data.offlineTime = this.formatTimestamp(data.offlineTime)
                    }
                    Object.assign(this.ruleForm, data)
                    this.registrationTime = [this.ruleForm.registrationStartTime, this.ruleForm.registrationEndTime]
                }
            })
        },
        requestInfo() {
            let params = {
                id: this.$route.query.id,
                name: this.ruleForm.name,
                onlineTime: this.ruleForm.onlineTime ? new Date(this.ruleForm.onlineTime).getTime() : '',
                registrationStartTime: this.ruleForm.registrationStartTime ? new Date(this.ruleForm.registrationStartTime).getTime() : '',
                registrationEndTime: this.ruleForm.registrationEndTime ? new Date(this.ruleForm.registrationEndTime).getTime() : '',
                offlineTime: this.ruleForm.offlineTime ? new Date(this.ruleForm.offlineTime).getTime() : '',
                status: this.ruleForm.status,
                pcBannerImage: this.ruleForm.pcBannerImage,
                h5BannerImage: this.ruleForm.h5BannerImage,
                backgroundColor: this.ruleForm.backgroundColor,
                rules: this.ruleForm.rules,
            }
            if (this.$route.query.id) {
                this.$apis.activityEnrollServer.update(params).then(res => {
                    if (res['code'] == 0) {
                        this.$message.success('修改成功！')
                        this.close()
                    }
                })
            } else {
                this.$apis.activityEnrollServer.add(params).then(res => {
                    if (res['code'] == 0) {
                        this.$message.success('添加成功！')
                        this.close()
                    }
                })
            }
        },
        handleConfig(row) {
            if (row.key === 'banner') {
                this.initUploadData()
                this.bannerDialogVisible = true
            } else if (row.key === 'rules') {
                this.ruleDialogVisible = true
            }
        },
        handlePcImgChange(res) {
            this.uploadErrorInfo1 = ''
            if (res['code'] == 0) {
                this.ruleForm.pcBannerImage = res.data.link
                this.$refs['bannerFormRef'].validateField('pcBannerImage')
            } else {
                this.uploadErrorInfo1 = res.message
            }
        },
        handleH5ImgChange(res) {
            this.uploadErrorInfo2 = ''
            if (res['code'] == 0) {
                this.ruleForm.h5BannerImage = res.data.link
                this.$refs['bannerFormRef'].validateField('h5BannerImage')
            } else {
                this.uploadErrorInfo2 = res.message
            }
        },
        beforeUpload(file) {
            const isImage = file.type.startsWith('image/');
            if (!isImage) {
                this.$message.error('请上传图片文件！');
                return false;
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB！');
                return false;
            }
            return true;
        },
        handleImgError(res) {
            console.log(res)
        },
        initUploadData() {
            this.uploadErrorInfo1 = ''
            this.uploadErrorInfo2 = ''
        },
        submitBanner() {
            this.$refs['bannerFormRef'].validate(valid => {
                if (valid) {
                    this.$message.success('Banner配置保存成功！')
                    this.bannerDialogVisible = false
                }
            })
        },
        submitRule() {
            this.$refs['ruleFormRef'].validate(valid => {
                if (valid) {
                    this.$message.success('报名规则保存成功！')
                    this.ruleDialogVisible = false
                }
            })
        },
        onSubmit() {
          this.$refs['formRef'].validate( async valid => {
            if (valid) {
              // 检验banner配置
              if (!this.ruleForm.pcBannerImage || !this.ruleForm.h5BannerImage) {
                this.$alert('请完善banner及底色配置', '提示', {
                  confirmButtonText: '确定',
                  callback: () => {
                    this.bannerDialogVisible = true
                  }
                })
                return
              }
              // 检验报名规则配置
              if (!this.ruleForm.rules) {
                this.$alert('请完善报名规则配置', '提示', {
                  confirmButtonText: '确定',
                  callback: () => {
                    this.ruleDialogVisible = true
                  }
                })
                return
              }
              this.requestInfo()
            }
          })
        },
        onPreview() {
            // 检验banner配置
            if (!this.ruleForm.pcBannerImage || !this.ruleForm.h5BannerImage) {
                this.$alert('请完善banner及底色配置', '提示', {
                    confirmButtonText: '确定',
                    callback: () => {
                        this.bannerDialogVisible = true
                    }
                })
                return
            }
            // 检验报名规则配置
            if (!this.ruleForm.rules) {
                this.$alert('请完善报名规则配置', '提示', {
                    confirmButtonText: '确定',
                    callback: () => {
                        this.ruleDialogVisible = true
                    }
                })
                return
            }
            // 跳转到独立预览页面
            this.$router.push({
                path: '/activityEnroll/preview',
                query: {
                    pcBannerImage: this.ruleForm.pcBannerImage,
                    h5BannerImage: this.ruleForm.h5BannerImage,
                    backgroundColor: this.ruleForm.backgroundColor,
                    rules: encodeURIComponent(this.ruleForm.rules)
                }
            })
        },
        cancel() {
            const h = this.$createElement;
            this.$msgbox({
                title: '',
                message: h('p', null, [
                  h('p', null, '确定取消吗？ '),
                  h('p', null, '离开页面后已编辑的内容将会丢弃')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                center: true
            }).then(() => {
                    this.$router.back()
            })
        },
        close() {
            this.$refs['formRef'].resetFields();
            this.$router.push({
                path: '/activityEnroll/list',
                query:{
                date: Date.now()
              }
            });
        },
        formatTimestamp(timestamp) {
            if (!timestamp) return ''
            const date = new Date(timestamp)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        }
    }
}
</script>
<style scoped lang="scss">
	.el-message-box--center .el-message-box__message {
		font-size: 20px;
		color: #000000;
	}

	.page {
		background-color: #fff;
		padding: 30px;
		display: block;
		margin-top: 20px;
		border-radius: 4px;
	}

	.title {
		font-size: 18px;
		font-weight: bold;
		color: #303133;
		margin-bottom: 20px;
		padding-bottom: 10px;
		border-bottom: 1px solid #EBEEF5;
	}

	.section {
		margin-bottom: 30px;
	}

	.section-title {
		font-size: 14px;
		font-weight: bold;
		color: #606266;
		margin-bottom: 20px;
		padding-bottom: 10px;
		border-bottom: 1px solid #EBEEF5;
	}

	.el-form-item {
		margin-bottom: 25px;
	}

	.el-form-item__label {
		width: 100px !important;
		text-align: right;
		padding-right: 15px;
	}

	.required {
		color: #F56C6C;
		margin-right: 4px;
	}

	.w500 {
		width: 500px;
	}

	.w300 {
		width: 300px;
	}

	.w100 {
		width: 100px;
	}

	.separator {
		margin: 0 10px;
		color: #909399;
	}

	.tip {
		display: block;
		line-height: 24px;
		font-size: 12px;
		color: #909399;
	}

	.config-table {
		margin-top: 10px;
	}

	.config-table .el-table__header {
		background-color: #F5F7FA;
	}

	.config-table .el-table__header th {
		background-color: #F5F7FA;
		color: #606266;
		font-weight: bold;
	}

	.foot {
		text-align: center;
		margin-top: 40px;
	}

	.foot .el-button {
		margin: 0 10px;
	}
	
	/* 弹窗样式 */
	.upload-box {
		position: relative;
        width: 80%;
	}
	.upload-tip {
		display: block;
		margin-top: 8px;
		font-size: 12px;
		color: #909399;
	}
    .backgroundColor-btn {
        width: 450px;
    }
    /deep/ .el-textarea .el-input__count {
        bottom: -40px;
    }
</style>